import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { Group } from 'src/app/common-class/pages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-thumbs-up',
  templateUrl: './thumbs-up.component.html',
  styleUrls: ['./thumbs-up.component.css'],
 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThumbsUpComponent implements OnInit {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() isGrid: boolean;
  @Input() group: Group;
  @Input() isNewParticipationButton : boolean;
  @Input() isStandAlone: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;

  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean = false;
  isAriaRequired: boolean;
  resetPageSub: any;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];
    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
    }
  }

  constructor(private service: ParticipationDataService, private changeDetect: ChangeDetectorRef) { }

  ngOnInit() {

    if (this.questions == null) {

      this.questions = JSON.parse(this.JsonData);
      if(this.questions.population_type ==3 )
      {
          this.isAnsChange = true;
      }

      this.isNewParticipation = this.service.isNewParticipation;
      this.surveyFormat = this.service.surveyFormat;
      this.newParticipationBtnText = this.service.newParticipationBtnText;
      this.showNewParticipationButton = this.isNewParticipationButton && (!this.service.isAutoScroll || this.questions.population_type==3);
      this.isAriaRequired = (this.questions.mandatory && this.isMandatoryUpfront) || (this.questions.mandatory && this.questions.isMandatoryInvalid);
    }
    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });
  }
  ngAfterViewInit() {
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });
    var self = this;
    let id = "#dv_" + this.questions.UniqueNumber;
    if($(id).find('.ld-label-text').length > 0){
      $(id).find('.ld-label-text').each(function() {
        self.lineLimitter($(this), 2);
      });
    }
  }
  ngOnDestroy(){
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }
  clickEvent(answer: Answers) {

    if (answer.selectdId == 0) {
      this.RadioButtonSelectedValue(answer);
    } else {
      this.RadioButtonClickEventHandling(answer);
    }
  }

  RadioButtonSelectedValue(answer: Answers) {
    for (let i = 0; i < this.questions.Answers.length; i++) {
      if (answer.ms_id === this.questions.Answers[i].ms_id) {
        answer.selectdId = 1;
        answer.ControlAns = answer.value_text;
        this.questions.Answers[i] = answer;
        this.questions.AnswerID = answer.ms_id;
        this.questions.selectAnsValue = answer.value_id;
        this.questions.AnswerText = answer.value_text;
        this.questions.pageto = answer.pageto;
        this.questions.otherAnswer = null;

        if (this.questions.isSoftRequired) {
          this.questions.isSoftRequiredHandle = true;
        }

        if (answer.isOther) {
          this.questions.isOtherAnswer = true;
        }
        else {
          this.questions.isOtherAnswer = false;
        }
      }
      else {
        this.questions.Answers[i].ControlAns = null;
        this.questions.Answers[i].selectdId = 0;
      }
    }
    this.isAnsChange = true;
    this.changeDetect.detectChanges();
    this.ChangeAnswersData.emit(this.questions);
  }

  RadioButtonClickEventHandling(answer: Answers) {
    if (answer.selectdId == 0) {
      return;
    }

    if (this.questions != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = this.questions.Answers.find(e => e.ms_id == answer.ms_id);
      let index = this.questions.Answers.indexOf(updateItem);
      this.questions.Answers[index] = answer;
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;
      this.questions.pageto = 0;
      this.questions.AnswerText = null;
      this.questions.otherAnswer = null;
      this.questions.isOtherAnswer = false;
      this.isAnsChange = true;
      this.changeDetect.detectChanges();
      this.ChangeAnswersData.emit(this.questions);

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = false;
      }
    }
  }

  nextQuestion(event) {
    if (this.service.isNewParticipation && (this.service.surveyFormat == 1 || this.service.surveyFormat == 2) && this.service.isAutoScroll) {
      // var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      // if (nextbtnLength > 0) {
      //   var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
      //   $('html,body').animate({
      //     scrollTop: (elemPosition - $(window).height() / 3)
      //   }, 400);
      // } else {
      //   var scrollVal = $('.tblPageFooter').offset().top;
      //   $('html,body').animate({
      //     scrollTop: scrollVal
      //   }, 400);
      // }
      if (this.isStandAlone) {
        var MatrixelemPosition;
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
        //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
        var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
        if (MatrixelemPosition.length > 0) {
          MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition - $(window).height() / 3)
          }, 400);
        } else if (MatrixelemPosition1.length > 0) {
          //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
          }, 400);
        } else {
          this.service.gotoNextQuestion(this.questions, event);
        }
      } else {
        this.service.gotoNextQuestion(this.questions, event);
      }
    }
    else if (this.service.surveyFormat == 3) {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find(".question-data").attr("hidden");

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }

  gotoNextQuestion(question: Questions, event) {
    if (this.isStandAlone) {
      var MatrixelemPosition;
      MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
      //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
      var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
      if (MatrixelemPosition.length > 0) {
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
        //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
        //MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
        $('html,body').animate({
          scrollTop: (MatrixelemPosition - $(window).height() / 3)
        }, 400);
      } else if (MatrixelemPosition1.length > 0) {
        //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
        //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
        MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
        $('html,body').animate({
          scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
        }, 400);
      } else {
        this.service.gotoNextQuestion(this.questions, event);
      }
    } else {
      this.service.gotoNextQuestion(this.questions, event);
    }
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }
  lineLimitter(obj, lines){
    var a = parseInt(obj.css('line-height'));
    if(isNaN(a)){
      a = parseInt(obj.css('font-size')) * 1.25;
    }
    a = a + 3;
    if(lines*a < obj.outerHeight()){
      obj.css({
        height: lines*a + 'px',
        overflow: 'hidden'
      });
      obj.addClass('lineLimitter');
    }
  }
  // getOpacity(question: Questions,answer: Answers): string {
  //   if(answer.ControlAns==null && (question.Answers[0].ControlAns!=null||question.Answers[1].ControlAns!=null)){
  //     return 'ld-unselect';
  //   }else{
  //     return'';
  //   }
  // }
  getPalette(questions: Questions,answers: Answers): string {
    var PaletteID = questions.PaletteID;
    var value_id = answers.value_id;
    var unselect = '';
    if(answers.ControlAns==null && (questions.Answers[0].ControlAns!=null||questions.Answers[1].ControlAns!=null)){
      unselect = ' ld-unselect';
    }
    if (PaletteID == 1 && value_id == 1) {
      return 'ld-common Palette_1_font_1'+unselect;
    }else if(PaletteID==1 && value_id==2){
      return 'ld-common Palette_1_font_2'+unselect;
    }else if(PaletteID==2 && value_id==1){
      return 'ld-common Palette_2_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==2 && value_id==2){
      return 'ld-common Palette_2_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==3 && value_id==1){
      return 'ld-common Palette_3_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==3 && value_id==2){
      return 'ld-common Palette_3_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==4 && value_id==1){
      return 'ld-common Palette_4_font_1'+unselect;
    }else if(PaletteID==4 && value_id==2){
      return 'ld-common Palette_4_font_2'+unselect;
    }else if(PaletteID==5 && value_id==1){
      return 'ld-common Palette_5_font_1'+unselect;
    }else if(PaletteID==5 && value_id==2){
      return 'ld-common Palette_5_font_2'+unselect;
    }else if(PaletteID==6 && value_id==1){
      return 'ld-common Palette_6_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==6 && value_id==2){
      return 'ld-common Palette_6_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==7 && value_id==1){
      return 'ld-common Palette_7_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==7 && value_id==2){
      return 'ld-common Palette_7_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==8 && value_id==1){
      return 'ld-common Palette_8_font_1'+unselect;
    }else if(PaletteID==8 && value_id==2){
      return 'ld-common Palette_8_font_2'+unselect;
    }else if(PaletteID==9 && value_id==1){
      return 'ld-common Palette_9_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==9 && value_id==2){
      return 'ld-common Palette_9_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==10 && value_id==1){
      return 'ld-common Palette_10_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==10 && value_id==2){
      return 'ld-common Palette_10_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==11 && value_id==1){
      return 'ld-common Palette_11_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==11 && value_id==2){
      return 'ld-common Palette_11_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==12 && value_id==1){
      return 'ld-common Palette_12_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==12 && value_id==2){
      return 'ld-common Palette_12_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==13 && value_id==1){
      return 'ld-common Palette_13_icon_1 Palette_icon'+unselect;
    }else if(PaletteID==13 && value_id==2){
      return 'ld-common Palette_13_icon_2 Palette_icon'+unselect;
    }else if(PaletteID==14 && value_id==1){
      return 'ld-common Palette_14_font_1'+unselect;
    }else if(PaletteID==14 && value_id==2){
      return 'ld-common Palette_14_font_2'+unselect;
    }else if(value_id==1){
      return 'ld-common Palette_1_font_1';
    }else if(value_id==2){
      return 'ld-common Palette_1_font_2';
    }else{
      return '';
    }
    
  }

  getPaletteicon(questions: Questions): string {
    var PaletteID = questions.PaletteID;
    if(PaletteID==2){
      return 'Palette_icon_ld';
    }else if(PaletteID==3){
      return 'Palette_icon_ld';
    }else if(PaletteID==6){
      return 'Palette_icon_ld';
    }else if(PaletteID==7){
      return 'Palette_icon_ld';
    }else if(PaletteID==9){
      return 'Palette_icon_ld';
    }else if(PaletteID==10){
      return 'Palette_icon_ld';
    }
    else if(PaletteID==11){
      return 'Palette_icon_ld1';
    }
    else if(PaletteID==12){
      return 'Palette_icon_ld';
    }else if(PaletteID==13){
      return 'Palette_icon_ld';
    }else if(PaletteID==13){
      return 'Palette_icon_ld';
    }else{
      return '';
    }
  }
}
